export const state = {
  personalAccountInfo: null,
  personalAccounts: []
};

export const getters = {
  getPersonalAccountInfo: state => state.personalAccountInfo,
  getPersonalAccounts: state => state.personalAccounts
};

export default {
  state,
  getters
};
